<template>
    <div class="col-sm-4" v-if="can('transporters.index','buses.index','bus.types.index')">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">{{i18n("Work with transporter")}}</h1>
            </div>
            <div class="card-body">
                <ul class="list-unstyled grid-list">
                    <router-link to="/bus-types" tag="li" v-if="can('bus.types.index')">
                        <a href="#" title="">{{i18n("Bus types")}}</a>
                    </router-link>
                    <router-link to="/transporters" tag="li" v-if="can('transporters.index')">
                        <a href="#" title="">{{i18n('Transporters')}}</a>
                    </router-link>
                    <router-link to="/buses/index" tag="li" v-if="can('buses.index')">
                        <a href="#" title="">{{i18n("Buses")}}</a>
                    </router-link>

                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TransportersCard"
    }
</script>

<style scoped>

</style>
